import crypto from 'crypto'
function encryptString(text: string) {
  if (!text) return
  return crypto.createHash('sha256').update(text.toLowerCase()).digest('hex')
}
export default encryptString
